import { IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import { Box, Skeleton } from '@mui/material';

const styles: IStyles = {
  root: {
    width: '100%',
    boxSizing: 'border-box',
    overflowX: 'hidden',
    p: {
      xs: pxToRem(20),
      lg: `${pxTovW(30)} ${pxTovW(240)} ${pxTovW(100)}`,
    },
  },

  header: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: { xs: pxToRem(20), md: pxToRem(24), lg: pxTovW(30) },
    paddingBottom: { xs: pxToRem(20), md: pxToRem(21), lg: pxTovW(25) },
    justifyContent: { xs: 'flex-start', md: 'space-between' },
    alignItems: { md: 'center' },
  },

  chapterCard: {
    display: 'flex',
    gap: { xs: pxToRem(16), md: pxToRem(18), lg: pxTovW(20) },
    alignItems: 'center',
    width: { xs: '100%', lg: pxTovW(960) },
  },

  chapterImage: {
    width: { xs: pxToRem(90), md: pxToRem(78), lg: pxTovW(120) },
    height: { xs: pxToRem(90), md: pxToRem(60), lg: pxTovW(90) },
    borderRadius: pxToRem(12),
    flexShrink: 0,
  },

  headerButton: {
    display: { xs: 'none', md: 'block' },
    width: { md: pxTovW(444) },
    height: { xs: pxToRem(52), md: pxToRem(48), lg: pxTovW(70) },
    borderRadius: pxToRem(12),
    flexShrink: 0,
  },

  bodySection: {
    display: 'flex',
    gap: { xs: pxToRem(20), md: pxToRem(42), lg: pxTovW(60) },
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: { xs: 'flex-start', md: 'space-between' },
  },

  leftPanel: {
    width: { xs: '100%', md: '45%', lg: pxTovW(590) },
    flexBasis: { md: '45%', lg: pxTovW(590) },
  },

  infoBar: {
    width: '100%',
    height: { xs: pxToRem(80), md: pxToRem(72), lg: pxTovW(110) },
    borderRadius: pxToRem(12),
  },

  rightPanel: {
    width: { xs: '100%', md: '55%', lg: pxTovW(727) },
  },

  resourcesHeading: {
    width: { xs: pxToRem(120), md: pxToRem(90), lg: pxTovW(140) },
    height: { xs: pxToRem(24), md: pxToRem(23), lg: pxTovW(28) },
    borderRadius: pxToRem(6),
  },

  cardsContainer: {
    paddingTop: { xs: pxToRem(18), lg: pxTovW(20) },
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(20), md: pxToRem(18), lg: pxTovW(20) },
  },

  resourceCard: {
    width: '100%',
    height: { xs: pxToRem(127), md: pxToRem(105), lg: pxTovW(165) },
    borderRadius: pxToRem(12),
  },
};

export const ActiveProjectDetailsShimmer = () => {
  return (
    <Box sx={styles.root}>
      <Box sx={styles.header}>
        <Box sx={styles.chapterCard}>
          <Skeleton variant="rectangular" sx={styles.chapterImage} />
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: pxToRem(10) }}>
            <Skeleton variant="text" sx={{ width: '70%', fontSize: pxToRem(22) }} />
            <Skeleton variant="text" sx={{ width: '40%', fontSize: pxToRem(16) }} />
          </Box>
        </Box>
        <Skeleton variant="rectangular" sx={styles.headerButton} />
      </Box>

      <Box sx={styles.bodySection}>
        <Box sx={styles.leftPanel}>
          <Skeleton variant="rectangular" sx={styles.infoBar} />
        </Box>

        <Box sx={styles.rightPanel}>
          <Skeleton variant="rectangular" sx={styles.resourcesHeading} />
          <Box sx={styles.cardsContainer}>
            {Array.from({ length: 3 }, (_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                sx={styles.resourceCard}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ActiveProjectDetailsShimmer;
